import { createRouter, createWebHistory } from 'vue-router'
//import { isLoggedIn } from '@/utils/auth'
import ParkingSelection from '../views/ParkingSelection.vue'
import ParkingDiscount from '../views/ParkingDiscount.vue'
import UserProfile from '../views/UserProfile.vue'
import BusinessCooperation from '@/views/cooperation/BusinessCooperation.vue'
import ParkingLotCooperation from '@/views/cooperation/ParkingLotCooperation.vue'
import MerchantCooperation from '@/views/cooperation/MerchantCooperation.vue'
import VehicleCooperation from '@/views/cooperation/VehicleCooperation.vue'
import TechCooperation from '@/views/cooperation/TechCooperation.vue'
import DataCooperation from '@/views/cooperation/DataCooperation.vue'
import {setupGuards} from "@/permission";
// Remove the unused imports - this was causing the ESLint errors

const routes = [
  // Login route should be accessible to everyone
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/auth/register',
    name: 'Register',
    component: () => import('@/views/auth/Register.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/auth/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/auth/ResetPassword.vue'),
    meta: { requiresAuth: false }
  },

  // Home route should redirect to login if not authenticated
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/parking',
    name: 'ParkingSelection',
    component: ParkingSelection
  },
  {
    path: '/city-selector',
    name: 'CitySelector',
    component: () => import('@/views/CitySelector.vue')
  },
  {
    path: '/discount',
    name: 'ParkingDiscount',
    component: ParkingDiscount
  },
  {
    path: '/profile',
    name: 'UserProfile',
    component: UserProfile
  },

  // User vehicle sub-pages - fixed the paths
  {
    path: '/user/vehicle',
    children: [
      {
        path: 'list',
        name: 'VehicleList',
        component: () => import('../views/user/vehicle/VehicleList.vue'),
        meta: { title: '我的车辆', icon: 'car' }
      },
      {
        path: 'verification',
        name: 'VehicleVerification',
        // Fixed: Verification.vue, not verification directory
        component: () => import('../views/user/vehicle/Verification.vue'),
        meta: { title: '选择认证类型', activeMenu: '/user/vehicle/list' },
        hidden: true
      },
      {
        path: 'personal',
        name: 'PersonalCertification',
        component: () => import('../views/user/vehicle/PersonalCertification.vue'),
        meta: { title: '个人车辆认证', activeMenu: '/user/vehicle/list' },
        hidden: true
      },
      {
        path: 'company',
        name: 'CompanyCertification',
        component: () => import('../views/user/vehicle/CompanyCertification.vue'),
        meta: { title: '企业车辆认证', activeMenu: '/user/vehicle/list' },
        hidden: true
      }
    ]
  },
  {
    path: '/user/vehicle/add',
    name: 'VehicleAdd',
    component: () => import('../views/user/vehicle/VehicleAdd.vue')
  },
  {
    path: '/user/vehicle/test',
    name: 'test',
    component: () => import('../views/user/vehicle/test.vue')
  },


  {
    path: '/user/vehicle/edit/:id',
    name: 'VehicleEdit',
    component: () => import('../views/user/vehicle/VehicleEdit.vue'),
    props: true
  },

  // Monthly card sub-pages
  {
    path: '/parking/monthly-card/list',
    name: 'MonthlyCardList',
    component: () => import('@/views/parking/monthly-card/MonthlyCardList.vue')
  },
  {
    path: '/parking/monthly-card/apply/success',
    name: 'MonthlyCardApplySuccess',
    component: () => import('@/views/parking/monthly-card/ApplySuccess.vue')
  },
  {
    path: '/parking/monthly-card/apply',
    name: 'MonthlyCardApply',
    component: () => import('@/views/parking/monthly-card/MonthlyCardApply.vue'),
    props: true
  },
  {
    path: '/parking/monthly-card/details/:id',
    name: 'MonthlyCardDetails',
    component: () => import('@/views/parking/monthly-card/MonthlyCardDetails.vue'),
    props: true
  },
  {
    path: '/parking/monthly-card/selection',
    name: 'MonthlyCardSelection',
    component: () => import('@/views/parking/monthly-card/ParkingSpaceSelection.vue')
  },

  {
    path: '/parking/monthly-card/MyMonthlyCard',
    name: 'MyMonthlyCard',
    component: () => import('@/views/parking/monthly-card/MyMonthlyCard.vue')
  },

  {
    path: '/parking/monthly-card',
    redirect: '/parking/monthly-card/selection'
  },

  {
    path: '/parking/monthly-card/renewal',
    name: 'MonthlyCardRenewal',
    component: () => import('@/views/parking/monthly-card/MonthlyCardQuickRenewal.vue')
  },
  // Update sharing routes to use existing files

  {
    path: '/parking/ReserveParkingSpot',
    name: 'ReserveParkingSpot',
    component: () => import('@/views/parking/ReserveParkingSpot.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/parking/ReserveParkingSpotInfo/:id',
    name: 'ReserveParkingSpotInfo',
    component: () => import('@/views/parking/ReserveParkingSpotInfo.vue'),
    meta: { requiresAuth: true }
  },


  {
    path: '/parking/sharing',
    name: 'ParkingSharing',
    component: () => import('@/views/parking/sharing/index.vue'),
    meta: { requiresAuth: true }
  },
  // Temporarily comment out routes to files that don't exist yet
  // {
  //   path: '/parking/sharing/my-listings',
  //   name: 'MySharedListings',
  //   component: () => import('../views/parking/sharing/my-listings'),
  //   meta: { title: '我的共享', icon: 'list' },
  //   hidden: true
  // },
  {
    path: '/parking/sharing/edit/:id',
    name: 'EditSharedListing',
    component: () => import('@/views/parking/sharing/index.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/parking/visitor-apply',
    name: 'VisitParkingApply',
    component: () => import('@/views/parking/visitor-apply/visitParkingApply.vue'),
    meta: { requiresAuth: true, title: '访客停车申请' }
  },

  // Order-related routes
  {
    path: '/user/order',
    name: 'OrderList',
    component: () => import('../views/user/order/OrderList.vue')
  },
  {
    path: '/user/order/:id',
    name: 'OrderDetail',
    component: () => import('../views/user/order/OrderDetail.vue'),
    props: true
  },
  {
    path: '/user/order/:id/payment',
    name: 'OrderPayment',
    component: () => import('../views/user/order/OrderPayment.vue'),
    props: true
  },
  {
    path: '/user/invoice/apply/:orderId',
    name: 'InvoiceApply',
    component: () => import('@/views/user/invoice/InvoiceApply.vue'),
    meta: { title: '申请开具发票', requiresAuth: true }
  },
  {
    path: '/user/refund-apply/:orderId',
    name: 'RefundApply',
    component: () => import('@/views/user/refundApply/RefundApply.vue'),
    meta: { title: '申请退款', requiresAuth: true }
  },

  // Parking spot management routes
  {
    path: '/user/parking-spot',
    name: 'ParkingSpotList',
    component: () => import('../views/user/parking-spot/ParkingSpotList.vue')
  },
  {
    path: '/user/parking-spot/:id',
    name: 'ParkingSpotDetail',
    component: () => import('../views/user/parking-spot/ParkingSpotDetail.vue'),
    props: true
  },
  {
    path: '/user/parking-spot/reserve',
    name: 'ParkingSpotReserve',
    component: () => import('../views/user/parking-spot/ParkingSpotReserve.vue')
  },
  {
    path: '/user/parking-spot/:id/edit',
    name: 'ParkingSpotEdit',
    component: () => import('../views/user/parking-spot/ParkingSpotEdit.vue'),
    props: true
  },
  {
    path: '/user/parking-spot/:id/extend',
    name: 'ParkingSpotExtend',
    component: () => import('../views/user/parking-spot/ParkingSpotExtend.vue'),
    props: true
  },
  // Updated route to use the new file
  {
    path: '/user/parking-spot/:id/renew',
    name: 'ParkingSpotRenew',
    component: () => import('../views/user/parking-spot/SpotRenew.vue'),
    props: true
  },
  {
    path: '/user/parking-spot/:id/transfer',
    name: 'ParkingSpotTransfer',
    component: () => import('../views/user/parking-spot/ParkingSpotTransfer.vue'),
    props: true
  },
  {
    path: '/user/parking-spot/:id/status',
    name: 'ParkingSpotStatus',
    component: () => import('../views/user/parking-spot/ParkingSpotStatus.vue'),
    props: true
  },
  // Add these new routes
  {
    path: '/user/postpaid/guidance',
    name: 'PostPaidGuidance',
    component: () => import('../views/user/postpaid/PostPaidGuidance.vue')
  },
  {
    path: '/user/postpaid/detail',
    name: 'PostPaidDetail',
    component: () => import('../views/user/postpaid/PostPaidDetail.vue')
  },
  {
    path: '/user/settings',
    name: 'UserSettings',
    component: () => import('../views/user/settings/Settings.vue')
  },
  {
    path: '/user/settings/profile',
    name: 'ProfileEdit',
    component: () => import('../views/user/settings/ProfileEdit.vue')
  },
  {
    path: '/user/settings/phone',
    name: 'PhoneEdit',
    component: () => import('../views/user/settings/PhoneEdit.vue')
  },
  // Add these routes to your router configuration
  {
    path: '/user/location/settings',
    name: 'LocationSettings',
    component: () => import('../views/user/location/Settings.vue')
  },
  {
    path: '/user/location/usage-records',
    name: 'LocationUsageRecords',
    component: () => import('../views/user/location/UsageRecords.vue')
  },
  {
    path: '/user/location/auth-records',
    name: 'LocationAuthRecords',
    component: () => import('../views/user/location/AuthRecords.vue')
  },
  {
    path: '/user/invoice/management',
    name: 'InvoiceManagement',
    component: () => import('../views/user/invoice/InvoiceManagement.vue')
  },
  {
    path: '/user/invoice/detail/:id',
    name: 'InvoiceDetail',
    component: () => import('../views/user/invoice/InvoiceDetail.vue')
  },
  {
    path: '/user/feedback',
    name: 'UserFeedback',
    component: () => import('../views/user/feedback/Feedback.vue')
  },
  // Task management is for internal users only, not for vehicle owners
  // {
  //   path: '/user/task',
  //   name: 'MyTasks',
  //   component: () => import('../views/user/task/MyTasks.vue')
  // },
  {
    path: '/user/business',
    name: 'BusinessCooperation',
    component: () => import('../views/cooperation/BusinessCooperation.vue')
  },
  {
    path: '/user/privacy',
    name: 'PrivacyPolicy',
    component: () => import('../views/user/privacy/PrivacyPolicy.vue')
  },
  {
    path: '/user/profile/details',
    name: 'ProfileDetails',
    component: () => import('../views/user/profile/ProfileDetails.vue')
  },
  {
    path: '/user/profile/edit',
    name: 'ProfileEdit',
    component: () => import('../views/user/settings/ProfileEdit.vue')
  },
  {
    path: '/profile/edit',
    redirect: '/user/profile/edit'
  },
  // Add this to your routes array
  {
    path: '/parking/space/:id',
    name: 'ParkingSpaceDetail',
    component: () => import('@/views/parking/ParkingSpaceDetail.vue'),
    meta: { requiresAuth: true }
  },
  // Update these routes in your routes array
  {
    path: '/payment/confirm',
    name: 'PaymentConfirm',
    component: () => import('../views/payment/Confirm.vue'),
    meta: {
      title: '支付确认',
      requiresAuth: false
    }
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: () => import('@/views/payment/Success.vue'),
    meta: {
      title: '支付成功',
      keepAlive: false
    }
  },
  // Add this to your routes array
  {
    path: '/payment/package-spot',
    name: 'PackageSpot',
    component: () => import('@/views/payment/packageSpot.vue'),
    meta: {
      title: '确认订单',
      keepAlive: false
    }
  },

  // Add this to your routes array
  {
    path: '/payment/shared-spot',
    name: 'SharedSpot',
    component: () => import('@/views/payment/sharedSpot.vue'),
    meta: {
      title: '确认订单',
      keepAlive: false
    }
  },
  {
    path: '/payment/parking-details',
    name: 'ParkingDetails',
    component: () => import('@/views/payment/ParkingDetails.vue'),
    meta: {
      title: '停车详情',
      requiresAuth: false
    }
  },
  {
    path: '/cooperation',
    component: BusinessCooperation,
    meta: { title: '商务合作' }
  },
  {
    path: '/cooperation/parking-lot',
    component: ParkingLotCooperation,
    meta: { title: '停车场合作' }
  },
  {
    path: '/cooperation/merchant',
    component: MerchantCooperation,
    meta: { title: '商户合作' }
  },
  {
    path: '/cooperation/vehicle',
    component: VehicleCooperation,
    meta: { title: '车企合作' }
  },
  {
    path: '/cooperation/tech',
    component: TechCooperation,
    meta: { title: '技术合作' }
  },
  {
    path: '/cooperation/data',
    component: DataCooperation,
    meta: { title: '数据合作' }
  },
  {
    path: '/user/coupons',
    name: 'MyCoupons',
    component: () => import('@/views/user/coupon/MyCoupons.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/coupons/redeem/:id',
    name: 'CouponRedemption',
    component: () => import('@/views/user/coupon/CouponRedemption.vue'),
    meta: { requiresAuth: true }
  },
  // Add this route to your router configuration
  {
    path: '/parking/monthly-card/quick-renewal',
    name: 'MonthlyCardQuickRenewal',
    component: () => import('@/views/parking/monthly-card/MonthlyCardQuickRenewal.vue')
  },
  // Add this route to your router configuration
  {
    path: '/payment/qrcode/innercode',
    name: 'InnerCodePayment',
    component: () => import('@/views/payment/qrcode/innerCode.vue'),
    meta: { title: '场内码支付', icon: 'el-icon-s-finance' }
  },
  {
    path: '/payment/qrcode/lanecode',
    name: 'LaneCodePayment',
    component: () => import('@/views/payment/qrcode/laneCode.vue'),
    meta: { title: '出口码支付', icon: 'el-icon-s-finance' }
  },
  {
    path: '/redemption',
    name: 'Redemption',
    component: () => import('@/views/redemption/index.vue'),
    meta: { title: '优惠券兑换', noAuth: true }
  },
  // Always put the catch-all route at the end
  // {
  //   path: '/:pathMatch(.*)*',
  //   name: 'NotFound',
  //   component: () => import('@/views/NotFound.vue'),
  //   meta: { requiresAuth: false }
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
setupGuards(router)
// Navigation guard
// router.beforeEach((to, from, next) => {
//   console.log('Navigation:', from.path, '->', to.path);
//   console.log('Route meta:', to.meta);
//
//   const url = window.location.href
//
//   sessionStorage.setItem("page/setInitLink", url)
//
//   // Check if route requires authentication
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     console.log('Route requires authentication');
//
//     // Check if user is logged in
//     const loggedIn = isLoggedIn();
//     console.log('User is logged in:', loggedIn);
//
//     if (!loggedIn) {
//       console.log('Redirecting to login page');
//       // Redirect to login page with return URL
//       next({
//         path: '/login',
//         query: { redirect: to.fullPath }
//       });
//     } else {
//       console.log('User authenticated, proceeding');
//       next(); // User is authenticated, proceed
//     }
//   } else {
//     console.log('Route does not require auth, proceeding');
//     next(); // No auth required, proceed
//   }
// });

export default router
